
<template>

<v-app id="app">
 <CoreView></CoreView> 
   <FooterPerfil></FooterPerfil>
   <!-- <PerfilOpciones></PerfilOpciones> <v-app id="app"> -->
    </v-app>
</template>
<script>


import CoreView from '@/components/common/View'


// import PerfilOpciones from '@/components/common/PerfilOpciones.vue';


import FooterPerfil from '@/components/common/FooterPerfil';

export default {
  name: 'MenuUsuario',

  components: {
    CoreView,
        FooterPerfil,
        // PerfilOpciones
  }
};




</script>
